import "./../css/sass/styles.scss";

import { debouncer, documentReady, scrollToEl, slideUp, slideDown } from "./Utility/utils";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import "./components/slider";
import "./components/video";
import "./components/modal";
import "./components/accordion";
import "./components/nav";
import "./components/hero";
import "./components/service-grid";
import "./components/card-grid";
import "./components/forms";
import "./components/scroll-triggers";

import imagesLoaded from "imagesloaded";

////////// Add any petite vue stuff here
import { createApp } from "petite-vue";

import { postFeed } from "./components/news-careers-loadmore";
import { WorkArchive } from "./components/work-grid";

createApp({
  postFeed,
  WorkArchive,
}).mount();
///////////////////////////////////////

// Use this for all your js need
documentReady((event) => {
  const body = document.querySelector('body');

  // Remove empty p tags accidentally placed by wordpress editor
  var elements = document.querySelectorAll("p");
  Array.prototype.forEach.call(elements, function (el, i) {
    let content = el.innerHTML;
    content = content.replace(/\s+/g, "");
    if (!content) {
      el.parentNode.removeChild(el);
    }
  });

  // Smooth Scrolling Anchor links / Prevent Default on href="#" links
  document.addEventListener(
    "click",
    function (e) {
      // loop parent nodes from the target to the delegation node
      for (var target = e.target; target && target != this; target = target.parentNode) {
        if (target.matches("a")) {
          const href = target.getAttribute("href");
          if (/#/.test(href)) {
            const hash = href.substring(href.indexOf("#"));
            const hashTarget = document.getElementById(hash.substring(1));
            if (hash !== "#" && !!hashTarget && !hashTarget.classList.contains("modal")) {
              e.preventDefault();
              target.blur();
              scrollToEl(hashTarget);
            } else if (hash == "#") {
              e.preventDefault();
              target.blur();
            }
          }
          break;
        }
      }
    },
    false
  );

  // Add .leaving-page class when changing between pages on the site.
  document.addEventListener(
    "click",
    function (e) {
      // loop parent nodes from the target to the delegation node
      for (var target = e.target; target && target != this; target = target.parentNode) {
        if (target.matches("a")) {
          var currentLocation = window.location;
          const href = target.getAttribute("href");

          if(
          (e.target.hostname == currentLocation.hostname || href.indexOf(currentLocation.hostname) !== -1 || href.indexOf('/') == 0)
          && currentLocation.pathname !== e.target.pathname
          ){

            body.classList.add('site_link_clicked');

            setTimeout(function(){
              body.classList.remove('site_link_clicked');
            }, 20);
          }

          break;
        }
      }
    },
    false
  );

  window.addEventListener('beforeunload', function(e){
    if(body.classList.contains('site_link_clicked')){
      body.classList.add('leaving-page');
    }
  });

  // Load More Team Members
  const teamLoadMore = document.querySelectorAll(".team_grid__load_more a");
  if (!!teamLoadMore) {
    teamLoadMore.forEach((item) => {
      item.addEventListener("click", function (e) {
        const teamGrid = item.closest(".team_grid");
        const hiddenItems = teamGrid.querySelectorAll(".card_hidden");

        hiddenItems.forEach((card) => {
          card.classList.remove("card_hidden");
        });

        setTimeout(function(){
          ScrollTrigger.refresh();
        }, 10);

        item.classList.add("disabled");
      });
    });
  }

  // Load More Section Block
  const lms = document.querySelectorAll(".lms");
  if (!!lms) {
    lms.forEach((section) => {
      const buttonContainer = section.querySelector(".lms__trigger_wrap");
      const button = section.querySelector(".lms__trigger");
      const content = section.querySelector(".lms__content");

      button.addEventListener("click", () => {
        slideUp(buttonContainer);
        content.classList.remove("lms__hidden");
        slideDown(content);
        setTimeout(function(){
          ScrollTrigger.refresh();
        }, 10);
      });

      // Check if the hero has a side nav. If it does, open load more section of nav target is hidden
      const heroNavItems = document.querySelectorAll(".hero__nav_item a");
      if (!!heroNavItems) {
        heroNavItems.forEach((link) => {
          let linkTarget = link.getAttribute("href");
          // target = target.replace('#', '');
          targetEl = section.querySelector(linkTarget);
          if (!!targetEl) {
            link.addEventListener("click", () => {
              slideUp(buttonContainer);
              content.classList.remove("lms__hidden");
              slideDown(content);
            });
          }
        });
      }
    });
  }

  // Work Grid Filter Toggle
  const workFilter = document.querySelector('.work_grid__filterWrap');
  if(!!workFilter){
    const triggers = workFilter.querySelectorAll('.cta');
    const radioOptions = workFilter.querySelectorAll('input');
    const filters = workFilter.querySelector('.work_grid__filters');

    triggers.forEach(cta => {
      cta.addEventListener('click', (e) => {
        e.preventDefault();
        cta.blur();

        if(filters.classList.contains('active')){
          filters.classList.remove('active');
          filters.setAttribute('aria-hidden', 'true');
        }
        else {
          filters.classList.add('active');
          filters.setAttribute('aria-hidden', 'false');
        }
      });
    });

    radioOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        filters.classList.remove('active');
        filters.setAttribute('aria-hidden', 'true');

        // Scroll to top of work grid
        scrollToEl(workFilter.closest('.work_grid'));
      });
    });
  }

  // Set --screen-width variable for use in css. Defaults to 100vw, but this helps with accuracy
  function set_screen_width_var(){
    const screenWidth = (body.offsetWidth + 2) + 'px'; // add a couple pixels to avoid thin lines on sides of full width elements.
    body.style.setProperty('--screen-width', screenWidth);
  }
  set_screen_width_var();

  window.addEventListener('resize', function(){
    set_screen_width_var();
  });

  // Set body class to determine if it's a mac or pc, as typography position is slightly different
  const os = navigator.platform;
  if(os.indexOf('Win') !== -1){
    body.classList.add('is_windows');
  }
});

window.addEventListener("load", function (event) {
  // Preload images
  const preloadImages = () => {
    return new Promise((resolve, reject) => {
      var imgLoad = imagesLoaded(
        document.querySelectorAll("img"),
        {
          background: true,
        },
        resolve
      );
    });
  };
  preloadImages().then(() => {
    const bodyEl = document.getElementsByTagName("body")[0];
    var event = new CustomEvent("pageloaded");
    bodyEl.classList.remove("loading");
    document.dispatchEvent(event);
  });
});
